import { GetParticipationAnswersResponseDTO } from '@/core/dto/psychosocial-report/get-participation-answers';
import type { ParticipationAnswers } from '@/types/Psychosocial';

export class GetParticipationAnswersMapper {
	constructor(private readonly data: GetParticipationAnswersResponseDTO) {}

	toDomain(): ParticipationAnswers {
		return {
			participation: {
				id: this.data.participation.id,
				survey_id: this.data.participation.survey_id,
				employee_id: this.data.participation.employee_id,
				created_at: this.data.participation.created_at,
				updated_at: this.data.participation.updated_at
			},
			answers: this.data.answers.reduce((values, answer) => {
				const fieldName = `question_${answer.question_id}`;
				values[fieldName] = answer.value;
				return values;
			}, {} as Record<string, string | number>),
			percentage_completed: this.data.percentage_completed
		};
	}
}
